export default "__VITE_ASSET__f8a62d92__"